export const COUNTRY_REQUEST = 'COUNTRY_REQUEST';
export const COUNTRY_REQUEST_SUCCESS = 'COUNTRY_REQUEST_SUCCESS';
export const COUNTRY_REQUEST_ERROR = 'COUNTRY_REQUEST_ERROR';
export const COUNTRY_UPDATE = 'COUNTRY_UPDATE';

export const LOCATION_UPDATE = 'LOCATION_UPDATE';
export const LOCATION_UPDATE_SUCCESS = 'LOCATION_UPDATE_SUCCESS';
export const LOCATION_UPDATE_ERROR = 'LOCATION_UPDATE_ERROR';

export const locationUpdate = () => {
  return {
    type: LOCATION_UPDATE
  };
};

export const locationUpdateSuccess = (postalCode, locality, city) => {
  return {
    type: LOCATION_UPDATE_SUCCESS,
    postalCode,
    locality,
    city
  };
};

export const locationUpdateError = error => {
  return {
    type: LOCATION_UPDATE_ERROR,
    error
  };
};

export const countryRequest = () => {
  return {
    type: COUNTRY_REQUEST
  };
};

export const countryUpdate = (country, currency, isoCode3) => {
  return {
    type: COUNTRY_UPDATE,
    country,
    currency,
    isoCode3
  };
};

export const countryRequestSuccess = ({ country, currency, isoCode3 }) => {
  return {
    type: COUNTRY_REQUEST_SUCCESS,
    country,
    currency,
    isoCode3
  };
};

export const countryRequestError = error => {
  return {
    type: COUNTRY_REQUEST_ERROR,
    error
  };
};
